import { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ApplicationUIContext } from '../Provider/Provider';

const DrawerContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px ${({ isMobile }) => (isMobile ? '16px' : '24px')};
`;

const DrawerContent = ({ children }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return <DrawerContentWrapper isMobile={isMobile}>{children}</DrawerContentWrapper>;
};

DrawerContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
};

DrawerContent.defaultProps = {
  children: undefined,
};

export default DrawerContent;
